import { loggingContexts } from "../../root/modules/logs/data/logging-contexts.js";
import { log } from "../../root/modules/logs/log.js";
import { useMainStore } from "../store/mainStore.js";

const pubNubStatusLog = log(loggingContexts.pubnubStatus);

const pubNubEventCategoryToConnectionStateMap = {
  PNConnectedCategory: true,
  PNNetworkDownCategory: false,
  PNNetworkIssuesCategory: false,
  PNNetworkUpCategory: true,
  PNReconnectedCategory: true,
  PNUnexpectedDisconnectCategory: false,
};

export function handlePubNubStatus({ event }) {
  const { category } = event;

  const isConnected =
    pubNubEventCategoryToConnectionStateMap[category] ?? false;

  pubNubStatusLog.info("new PubNub status", { category, isConnected });

  const mainStore = useMainStore();

  mainStore.$patch((state) => {
    state.connected = isConnected;

    state.pubNubStatusTracker.push({
      category,
      connected: isConnected,
      timestamp: Date.now(),
    });
  });
}
